import React, { useState } from "react";
import MaterialTable from "material-table";
import Cookies from "universal-cookie";
import { config } from "../services/config";

import { deleteProductImage } from "../services/products/Product"

// COMPONENTS 

import AddProducts from "./addProducts/AddProducts.component";
import EditProducts from "./editProduct/EditProduct.component";

// COOKIE
const cookies = new Cookies();

const token = cookies.get("browser_ID");

const ProductsPage = () => {
  const [productsEdit, setProductsEdit] = useState();  
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard">
        <div style={{ position: "relative", zIndex: 0 }}>
          <a href="#add">
            <div className="table-addbutton text-rumpel">
              ADD
            </div>
          </a>
          <MaterialTable
            columns={[
              {
                title: "Thumbnail",
                field: "thumbnail",
                render: rowData => (
                  <img
                    alt="ProductsImage"
                    style={{ width: 250, borderRadius: 4 }}
                    src={rowData.thumbnail}
                  />
                )
              },
              { title: "Title", field: "product_name" },
              { title: "Description", field: "short_desc" }
            ]}
            data={query =>
              new Promise((resolve, reject) => {
                fetch(config.ourProducts + `/${query.pageSize}?page=${query.page + 1 }`, {
                  method: "GET",
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                  }
                })
                  .then(response => response.json())
                  .then(result => {
                    if (result.success || result.success === false) {
                      resolve({
                        data: result.data.data,
                        page: query.page,
                        totalCount: result.data.total
                      });
                    } else {
                      reject(console.log("error"));
                    }
                  });
              })
            }
            editable={{
              onRowDelete: oldData =>
                new Promise((resolve, reject) => {
                  fetch(config.deleteProduct + oldData.id, {
                    method: "DELETE",
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${token}`
                    }
                  })
                    .then(response => response.json())
                    .then(result => {
                      if (result.success) {
                        resolve();
                      } else {
                        reject(console.log("error"));
                      }
                    });
                }),
            }}
            detailPanel={rowData => {
              const deleteHandler = async (id) =>{
                console.log(id)
                let deleteImageResponse = await deleteProductImage(id);
                console.log("deleteImageResponse",deleteImageResponse)
                if(deleteImageResponse.data.success===true){
                  window.document.location.reload()
              }
                
              }
              return (
                <div
                  style={{
                    padding: 20,
                    display: "grid",
                    gridTemplateColumns: "repeat(9, 1fr)"
                  }}
                >
                  {rowData.images &&
                    rowData.images.map((item, index) => {
                      return (
                        <div
                        key={index}
                          style={{
                            position: "relative",
                            backgroundImage: `url(${item.images})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            gridTemplateColumns: "1fr",
                            height: 100,
                            width: 100
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              right: 10,
                              color: "red",
                              cursor: "pointer",
                              fontSize: 20
                            }}
                            className="font-averta text-bold"
                            onClick={() => deleteHandler(item.id)}
                          >
                            x
                          </div>
                        </div>
                      );
                    })}
                </div>
              );
            }}
            actions={[
              {
                icon: "edit",
                tooltip: "Edit",
                onClick: (event, rowData) => {
                  setProductsEdit(rowData)
                  handleClickOpen()
                }
              }
            ]}
            title="Products"
            options={{
              actionsColumnIndex: -1,
              emptyRowsWhenPaging: false,
              search: false
            }}
          />
        </div>
        <div id="add" style = {{paddingTop: 150}}>
            <AddProducts/>
            
        </div>

        <EditProducts productValue={productsEdit} openStatus={open} onCloseClick={handleClose} />
      </div>
    </div>
  );
};

export default ProductsPage;
